import React from 'react';
import { withTranslation } from 'react-i18next';


const NodataFound = ({text, icon, t}) => {
    return(
        <div className="noDataShow text-center p-4">
            <img src={icon} alt={icon} />
            <h6>{t(text)}</h6>
        </div>
    )
}

export default withTranslation()(NodataFound);